'use client'

import type { TermineAccordionCamp } from '@/utilities/findCampsForTermineFilter'
import React, { useEffect, useState } from 'react'
import Termine from '@/components/Termine'

export type TermineWithCategoryFetchProps = {
  categoryId: string
  subCategoryId?: string
  showPastEvents?: boolean
  maxCamps?: number
  centered?: boolean
  twoColumns?: boolean
}

export function TermineWithCategoryFetch({
  categoryId,
  subCategoryId,
  showPastEvents,
  maxCamps,
  centered = false,
  twoColumns = false,
}: TermineWithCategoryFetchProps) {
  const [camps, setCamps] = useState<TermineAccordionCamp[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!categoryId) {
      setCamps([])
      setLoading(false)
      return
    }

    const load = async () => {
      try {
        setLoading(true)
        setError(null)
        const params = new URLSearchParams({ category: categoryId })
        if (subCategoryId) {
          params.append('subCategory', subCategoryId)
        }
        if (showPastEvents !== undefined) {
          params.append('showPastEvents', String(showPastEvents))
        }
        if (maxCamps !== undefined) {
          params.append('maxCamps', String(maxCamps))
        }
        const response = await fetch(`/api/get-camps?${params}`)
        if (!response.ok) throw new Error('Failed to fetch camps')
        const data = await response.json()
        setCamps(data.camps ?? [])
      } catch {
        setError('Fehler beim Laden der Termine')
        setCamps([])
      } finally {
        setLoading(false)
      }
    }

    void load()
  }, [categoryId, subCategoryId, showPastEvents, maxCamps])

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-gray-600">Lade Termine...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="py-8 text-center">
        <div className="text-red-600">{error}</div>
      </div>
    )
  }

  return (
    <Termine camps={camps} centered={centered} twoColumns={twoColumns} />
  )
}
